import {lazyComponent} from '@esgi/core/react';

export const UserProfile = lazyComponent(() => import('./modal'));
export {ManageAccount} from './profiles/teacher/components/manage-account';
export * from './types';
export * from './events';
export * from './utils';
